import React from 'react'
import { Outlet } from 'react-router-dom'

const CampusLife = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default CampusLife